import { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";
import { ApiError } from "@/api/client";
import { AuthShell, AuthSubmit } from "@/components/AuthShell";

export function TwoFactorChallengePage() {
  const pending = useAuthStore((s) => s.pending2FA);
  const complete = useAuthStore((s) => s.complete2FA);
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!pending) nav("/login", { replace: true });
  }, [pending, nav]);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await complete(code);
      nav("/projects", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "verification failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell subtitle="Enter the 6-digit code from your authenticator app, or a recovery code">
      <form onSubmit={onSubmit} className="flex flex-col gap-3.5" noValidate>
        <input
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="123456"
          autoFocus
          inputMode="numeric"
          aria-label="Authentication code"
          className="ef-input text-center font-mono text-lg tracking-[0.4em]"
        />
        {error && (
          <div className="rounded-[var(--radius-sm)] border border-ef-err/20 bg-ef-err/[0.08] px-3 py-2 text-xs text-ef-err">
            {error}
          </div>
        )}
        <AuthSubmit loading={busy || !code}>{busy ? "Verifying…" : "Verify"}</AuthSubmit>
      </form>
    </AuthShell>
  );
}
